var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErroricon = function SvgErroricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.6 0a6.4 6.4 0 1 0 12.8 0A6.4 6.4 0 0 0 1.6 8Zm6 1.6a.4.4 0 0 0-.4.4v.8c0 .22.18.4.4.4h.8a.4.4 0 0 0 .4-.4V10a.4.4 0 0 0-.4-.4h-.8Zm-.144-4.8h1.088a.4.4 0 0 1 .4.448l-.32 2.576a.2.2 0 0 1-.2.176h-.848a.2.2 0 0 1-.2-.176l-.32-2.576a.4.4 0 0 1 .4-.448Z",
    clipRule: "evenodd"
  })));
};
export default SvgErroricon;